<template>
	<div class="row">
		<!-- customar project  start -->
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<div class="table-responsive">
						<table
							id="report-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<th>S/N</th>
									<th>Elective Position</th>
									<th>Description</th>
									<th>Party Spending Limit</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="position in positions" :key="'p' + position.id">
									<td>{{ position.id }}.</td>
									<td>{{ position.name }}</td>
									<td>{{ position.description }}</td>
									<td>{{ position.limit }}</td>
									<td>
										<a
											@click.prevent="showEditModal(position)"
											href="#!"
											class="btn btn-info btn-sm"
											><i class="feather icon-edit"></i>&nbsp;Edit
										</a>
										<!-- <a href="#!" class="btn btn-danger btn-sm"
											><i class="feather icon-trash-2"></i>&nbsp;Delete
										</a> -->
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- customar project  end -->

		<!-- Edit Modal Start -->
		<Modal title="Edit Position">
			<form @submit.prevent="submitForm()" action="" method="post">
				<div class="form-group">
					<Alert />
				</div>

				<div class="form-group">
					<label for="position">Position</label>
					<input
						v-model="form.name"
						type="text"
						class="form-control"
						name="position"
						id="position"
						required
					/>
				</div>
				<div class="form-group">
					<label for="description">Description</label>
					<textarea
						v-model="form.description"
						class="form-control"
						name="description"
						id="description"
						rows="3"
						required
					></textarea>
				</div>
				<div class="form-group">
					<label for="limit">Spending Limit (₦)</label>
					<input
						v-model="form.limit"
						type="text"
						class="form-control"
						name="limit"
						id="limit"
						required
					/>
				</div>
				<div class="form-group">
					<div align="right" style="margin-top: 15px">
						<button
							@click.prevent="hideModal()"
							class="btn btn-secondary"
							style="margin-right: 5px; border-radius: 6px"
						>
							Cancel
						</button>
						<LoadingButton class="btn-info" style="border-radius: 6px">
							Submit</LoadingButton
						>
					</div>
				</div>
			</form>
		</Modal>
		<!-- Edit Modal End -->
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import Modal from "@/components/Modal.vue";
import Alert from "@/components/Alert.vue";
import { EventBus } from "@/utils/event_bus.js";
import LoadingButton from "@/components/LoadingButton.vue";

export default {
	components: {
		Modal,
		Alert,
		LoadingButton,
	},

	data() {
		return {
			form: {
				id: null,
				name: null,
				description: null,
				limit: null,
			},
		};
	},

	computed: {
		...mapGetters({
			positions: "settings/elective_positions",
		}),
	},

	methods: {
		showEditModal(position) {
			this.form.id = position.id;
			this.form.name = position.name;
			this.form.description = position.description;
			this.form.limit = position.raw_limit;

			EventBus.$emit("toggle-modal", "show");
		},

		submitForm() {
			this.$store
				.dispatch("settings/updateElectivePosition", this.form)
				.then((response) => {
					if (response === "success") {
						this.hideModal();
					}
				});
		},

		hideModal() {
			EventBus.$emit("toggle-modal", "hide");
		},
	},

	mounted() {
		if (!this.positions.length) {
			this.$store.dispatch("settings/getElectivePositions");
		}
	},
};
</script>
<style scoped>
.form-control {
	padding: 5px !important;
}
</style>
